import axios from "axios"
import store from "@/store"
import ESPService from "./esp.service"

const ATTEST_URL = import.meta.env.VITE_ATTEST_URL

let attestation = null

function getAttestation() {
  if (!attestation) {
    attestation = axios
      .get(ATTEST_URL, {
        baseURL: "",
        timeout: 3000,
        headers: {},
        transformRequest: [
          (body, headers) => {
            delete headers.common
            delete headers.Authorization
            return body
          },
        ],
      })
      .then(res => res.data?.data)
      .catch(() => {
        attestation = null
        return null
      })
  }
  return attestation
}

const ApiService = {
  init(baseURL) {
    axios.defaults.baseURL = baseURL
  },
  async refreshToken() {
    try {
      const refreshToken = localStorage.getItem("refresh_token")
      const response = await axios.post("/Account/RefreshToken", {
        userId: JSON.parse(localStorage.getItem("user_info")).id,
        refreshToken,
      })
      localStorage.setItem("refresh_token", response.data.refreshToken)
      localStorage.setItem("access_token", response.data.accessToken)
      this.setHeader()
      return response.data.accessToken
    } catch (error) {
      localStorage.clear()
      this.removeHeader()
      window.location.href = "/user/login"
      return false
    }
  },
  removeHeader() {
    axios.defaults.headers.common = {}
  },
  setHeader() {
    axios.defaults.headers.common.Authorization
      = `Bearer ${localStorage.getItem("access_token")}`
  },
  get(resource, config = {}) {
    return axios.get(encodeURI(resource), config)
  },
  get2(resource, data) {
    return axios.get(encodeURI(resource), { params: data })
  },
  post(resource, data) {
    return axios.post(resource, data)
  },
  post2(resource, data) {
    return axios.post(resource, null, { params: data })
  },
  formData(resource, data) {
    return axios.post(resource, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  },
  token(resource, data) {
    return axios.post(resource, data, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
    })
  },
  put(resource, data) {
    return axios.put(resource, data)
  },

  delete(resource) {
    return axios.delete(resource)
  },
  print(resourse, config = {}) {
    return axios.get(resourse, {
      ...config,
      responseType: "blob",
    })
  },
  printtemp(resourse, data) {
    return axios.post(resourse, data, {
      responseType: "blob",
    })
  },
  customRequest(data) {
    return axios(data)
  },
  signedData(data) {
    let objInfo = ""
    let certThumb = ""
    let receivedMsg = ""
    let myObj = ""
    let objSign = ""
    let msgSign = ""
    return new Promise((resolve, reject) => {
      const ws = new WebSocket("ws://localhost:8181")
      ws.onopen = function () {
        objInfo = { function: "getCertInfo" }
        ws.send(JSON.stringify(objInfo))
      }
      ws.onmessage = function (evt) {
        receivedMsg = evt.data
        try {
          myObj = JSON.parse(receivedMsg)
          if (myObj.status == "success") {
            if (myObj.certinfo == null) {
              receivedMsg = evt.data
              const myObjSign = JSON.parse(receivedMsg)
              if (myObjSign.status == "success") {
                const response = {
                  data: myObjSign,
                }
                resolve(response)
                ws.close()
              }
            }
            if (
              myObj.certinfo != null
              && Object.keys(myObj.certinfo).length > 0
            ) {
              certThumb = myObj.certinfo.thumbprint
              objSign = {
                function: "cryptoSign",
                obj: `${data}`,
                cms: false,
                detached: false,
                cert_thumb: ` ${certThumb}`,
                cert_sn: "",
                pin: "",
              }
              msgSign = JSON.stringify(objSign)
              ws.send(msgSign)
            }
            if (myObj.certinfo != null && Array.isArray(myObj.certinfo)) {
              certThumb = myObj.certinfo[0].thumbprint
              objSign = {
                function: "cryptoSign",
                obj: `${data}`,
                cms: false,
                detached: false,
                cert_thumb: ` ${certThumb}`,
                cert_sn: "",
                pin: "",
              }
              msgSign = JSON.stringify(objSign)
              ws.send(msgSign)
            }
          }
        } catch {
          const data1 = {
            response: {
              data: {
                status: 400,
                errors: ["ESP ключ не найден"],
              },
            },
          }
          reject(data1)
          ws.close()
        }
      }
      ws.onerror = (err) => {
        const errordata = {
          response: {
            data: {
              status: 400,
              errors: ["WebSocket connection failed"],
            },
          },
        }
        reject(errordata)
        ws.close()
      }
    })
  },
  async getSignedData(Service, data) {
    const signDataResponse = await Service.GetSignData(data.id)
    const signedDataResponse = await ESPService.signedData(
      signDataResponse.data.signData,
    )
    data.signedData = signedDataResponse.data.signedMsg
    return data
  },

  async getSignedDataMultiple(Service, data) {
    const signDatas = await Promise.all(
      data.map(async (item) => {
        const signDataResponse = await Service.GetSignData(item.id)
        return signDataResponse.data.signData
      }),
    )

    const signedDataResponse = await ESPService.signedDataMultiple(signDatas)

    data.forEach((e, i) => {
      e.signedData = signedDataResponse.data[i]
    })

    return data
  },
  async isRequireEsp() {
    const q = await this.post(`/account/IsRequireEsp`, {
      userName: JSON.parse(localStorage.getItem("user_info"))?.userName || "",
    }).then((res) => {
      return res.data.isRequireEsp
    })
    return q
  },
  async setSignData(Service, data) {
    const isRequireEsp = await ApiService.isRequireEsp()
    if (isRequireEsp) {
      if (Array.isArray(data)) {
        data = await ApiService.getSignedDataMultiple(Service, data)
      } else {
        data = await ApiService.getSignedData(Service, data)
      }
    }
    return data
  },

  mount401Interceptor() {
    const apies = [
      "/cashboxcurrentcondition/GetVirtualConditionByCurrency",
      "/cashboxcurrentcondition/GetConditionByCurrency",
      "/Announcement/GetNew",
    ]
    axios.interceptors.request.use(
      async (config) => {
        if (ATTEST_URL && config.url === ATTEST_URL)
          return config

        const accessToken = localStorage.getItem("access_token")
        if (accessToken) {
          config.headers.Authorization = `Bearer ${accessToken}`
        }
        if (ATTEST_URL) {
          const token = await getAttestation()
          if (token) {
            config.headers["X-Attestation"] = token
          }
        }
        const resUrl = config.url.split("?")[0]
        if (!apies.includes(resUrl)) {
          store.commit("SET_LAST_REQUEST_TIME", Date.now())
        }
        return config
      },
      (error) => {
        return Promise.reject(error)
      },
    )
    this._401interceptor = axios.interceptors.response.use(
      (response) => {
        const resUrl = response.config.url.split("?")[0]
        if (!apies.includes(resUrl)) {
          store.commit("SET_LAST_REQUEST_TIME", Date.now())
        }
        return response
      },
      async (error) => {
        const isRedirectLogin
          = (Date.now() - store.state.lastRequestTime) / (1000 * 60) > 15
        if (error.response) {
          const url = error.response.config.url.split("?")[0]
          if (url == "/Account/RefreshToken") {
            localStorage.clear()
            this.removeHeader()
            window.location.href = "/login"
          }
          if (error.response.status == 401) {
            if (isRedirectLogin && apies.includes(url)) {
              localStorage.clear()
              this.removeHeader()
              window.location.href = "/login"
            } else {
              const newAccessToken = await this.refreshToken()
              error.config.headers.Authorization = `Bearer ${newAccessToken}`
              return axios.request(error.config)
            }
          }
        }
        if (error.request.status == 403) {
          store.commit("SET_403_ERROR", true)
        }
        throw error
      },
    )
  },

  unmount401Interceptor() {
    axios.interceptors.response.eject(this._401interceptor)
  },
}

export default ApiService
